<template>
    <div>
        <header class="page-header">{{decodeURIComponent(workJson.workname)}}</header>
        <div class="page-container">
            <div class="subject-container">
                <div class="subject-left" style="background-color:#f6fcff;">
                    <div class="subject-top">
                        <!--  左侧内容  -->
                        <div class="subject-title">题面</div>
                        <!--  题面图片容器  -->
                        <div class="theme-box">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" :data-value="index"
                                         v-for="(item,index) in picUrls">
                                        <img class="item-img"
                                             style="max-height: 100%;max-width: 100%;width: 90%;height: 100%;"
                                             :src="item" v-on:click="previewImg(picUrls,index)">
                                    </div>
                                </div>
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>
                                <!-- Add Arrows -->
                                <div class="swiper-button-next"></div>
                                <div class="swiper-button-prev"></div>
                            </div>
                        </div>
                    </div>
                    <!--整体报告-->
                    <div class="subject-statistics">
                <span class="footer-left">
                    <span class="title">整体报告</span>
                </span>
                        <!--<div class="overallReport"-->
                        <!--v-if="submitList.length>1 || (submitList.length == 1 && submitList[0])"> <span>00 : 00</span>-->
                        <div class="overallReport"
                             v-if="isSetAfter">
                            <div class="answerCondition">
                                <div class="overallTitle">答题情况</div>
                                <div class="answerReport">
                                    <p>题型：<span>{{getQuestype(workJson.workjson.questype)}}</span></p>
                                    <p>用时：</p>
                                    <p>参与：<span>{{submitCount}}/{{totalStudentCount}}</span></p>
                                    <p>班级：<span>{{decodeURIComponent(JSON.parse(workJson.workjson).classname)}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="statisticReport">
                                <div class="overallTitle">统计报告</div>
                                <div style="width: 320px;height: 66px">
                                    <div class="importWrong">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <template v-for="(item,index) in wrongWeight">
                                            <span>{{item}}</span>
                                        </template>
                                    </div>
                                </div>
                                <div class="pieReport" style="height:94px;margin-top:10px;">
                                    <div id="pieContainer" style="width:94px;height:94px"></div>
                                    <div class="pieLegend">
                                        <p><span></span>优秀： <span class="excellentCount">{{Math.round(excellentCount * 100) + '%'}}</span>
                                        </p>
                                        <p><span style="background-color:#ffca51;"></span>良好： <span
                                            class="goodCount">{{Math.round(goodCount * 100) + '%'}}</span></p>
                                        <p><span style="background-color:#f98376;"></span>合格： <span
                                            class="badCount">{{Math.round(badCount * 100) + '%'}}</span></p>
                                        <p><span style="background-color:#ff9b57;"></span>不合格： <span
                                            class="notGood">{{Math.round(notGoodCount * 100) + '%'}}</span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="allRight">
                                <div class="overallTitle">全部答对</div>
                                <div class="listContainer" v-if="allRightIds.length===0">
                                    <p v-if="allRightIds.length===0">当前没有学生全部答对，</p>
                                    <p>请再接再厉哦！</p>
                                </div>
                                <div class="listContainer" v-else>
                                    <template v-for="(item,index) in allRightIds">
                                        <span>{{ students[item] }}</span>
                                    </template>
                                </div>
                                <!--<div class="keyEvaluation">-->
                                <!--一键评价（+5）-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="reportNull" v-else>
                            <!--<p class="reportShow defaultShow"></p>-->
                            <p class="reportShow onlineTipShow"></p>
                        </div>
                    </div>
                </div>
                <div class="subject-right fill-right">
                    <!--  右侧内容  -->
                    <div class="reportTitle">
                        <span>答题报告</span>
                    </div>
                    <ul class="result-list list-none ">
                        <template v-for="(item,index) in submitList">
                            <div class='result-item' :data-qid="item.quesid"
                                 v-if="item.raisehandsList.length<=0 || (item.raisehandsList.length === 1 && item.raisehandsList[0] === '')">
                                <span class='rightAnswer'> 正确答案：{{item.rightAnswer}} </span>
                                <div class='chartItem' :id="'chartItem_zxt'+index"
                                     style="width:100%;height:90%;position: absolute;">
                                </div>
                            </div>
                            <div class='result-item' :data-qid="item.quesid" v-else>
                                <span class='rightAnswer'> 正确答案：{{item.rightAnswer}} </span>
                                <div class='askNumber unfoldIcon' v-on:click="lookStuNames($event)">提问人数 <span>{{item.raisehandsList.length}}</span>人
                                    <ul :class="'askStuName' + index">
                                        <li v-for="(subItem,subIndex) in item.raisehandsList">{{students[subItem]}}</li>
                                    </ul>
                                </div>
                                <div class='chartItem' :id="'chartItem_zxt'+index"
                                     style="width:100%;height:90%;position: absolute;">
                                </div>
                            </div>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <!--点击图表显示的人员名单弹框-->
        <div class="selectPersons" v-if="isShowModel">
            <div class="personsContainer">
                <div class="personHeader">学生名单</div>
                <div class="personContent">
                    <template v-for="(item,index) in stuList">
                        <span v-if="raisehandsList.indexOf(item)== -1">{{students[item]}}</span>
                        <span class='putHands' v-else>{{students[item]}}</span>
                    </template>
                </div>
                <div class="personFooter">
                    <span>共 <span class="stuCount">{{stuList.length}}</span> 人</span>
                    <button class="closePersonList" v-on:click="isShowModel=false">关闭</button>
                </div>
            </div>
        </div>
        <!-- 预览轮播 -->
        <!--<preview-slider-->
            <!--ref="previewSlider"-->
            <!--:previewMode="previewMode"-->
            <!--:previewVideoMode="previewVideoMode"-->
            <!--:videoSrc="videoSrc"-->
            <!--@closePreview="closePreview"-->
        <!--&gt;</preview-slider>-->

        <!-- 预览轮播 -->
        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as API from '../../../../service/cloudReport/index'
    // const previewSlider = () => import("../baseData/previewSlider");


    export default {
        name: "object-report",
        computed: {
            ...mapGetters([
                'interactPath',
                'interactPBPath'
            ]),
        },
        // components: {
        //     previewSlider
        // },
        data () {
            return {
                workId: this.$route.params.workId,
                isSetAnswer: '',//是否设置过答案
                reportObj: null,
                userListPB: null,
                questionInfoPb: null,
                calcPB: null,
                quesDetailsPb: null,
                students: [],
                workJson: '',//pb文件中取出的报告json
                workjson: '',
                picUrls: [],//题目集合,
                submitCount: 0,//提交人数
                submitList: [],
                submitListIds: [],
                fillList: [],
                questions: [],
                calcData: {},//小题集合
                answerList: [],
                userList: [],
                allRightIds: [],
                excellentIds: [],
                goodIds: [],
                badIds: [],
                notGoodIds: [],
                totalStudentCount: 0,
                excellentCount: 0,
                goodCount: 0,
                badCount: 0,
                notGoodCount: 0,
                wrongWeight: [],         //错题权重
                raisehandsList: [],// 举手人员列表
                colorArr: ['#5cb3ff', '#ffca51', '#f98376', '#FF9B57'],
                isSetAfter: false,
                stuList: [],
                isShowModel: false,
                previewMode: false,
                previewVideoMode: false,
                videoSrc: ""
            }
        },
        methods: {
            /**
             * 获取userList
             */
            loadUserList () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fuserlist.pb",
                    pb: _this.userListPB,
                    success: function (resp) {
                        try {
                            if (Object.keys(resp).length === 0) { // 判断指定参数是否是一个空对象
                                var logStr = "学生列表:" + JSON.stringify(resp);
                                console.error(logStr);
                            }
                            _this.loadUserObj(resp);
                            _this.getInertactInfo();
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    fail: function () {
                        console.error("get resource err url=" + _this.interactPBPath + this.workId + "%2Fuserlist.pb");
                    }
                });
            },
            /**
             *  处理学生对象
             */
            loadUserObj (u) {
                // localStorage.setItem('stuListLength',u.userlist.length);
                for (var i = 0; i < u.userlist.length; i++) {
                    var uid = u.userlist[i].stuid.replace(/m_/g, '');
                    this.students[uid] = decodeURIComponent(u.userlist[i].stuname);
                    this.userList.push(uid);
                }
                this.totalStudentCount = Object.keys(this.students).length;
            },
            /**
             * 根据报告id获取报告详情
             */
            async getInertactInfo () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fwork.pb",
                    pb: _this.questionInfoPb,
                    success: function (resp) {
                        try {
                            _this.workJson = resp;
                            _this.loadWorkObj(resp);
                            _this.loadCalcJson();
                        }
                        catch (error) {
                        }
                    },
                    fail: function () {
                        console.error("get resource err url=" + _this.interactPBPath + this.workId + "%2Fwork.pb");
                    }
                });
            },
            getData (option) {
                // fetcdhGET(option.url + "?version=" + new Date().getTime(), {resType: "arraybuffer"}).then((resp) => {
                //     var res = option.pb.decode(resp);
                //     console.log(res);
                //     option.success(res);
                // }, (error) => {
                //     console.error(error);
                //     option.fail();
                // });

                API.GET(option.url + "?version=" + new Date().getTime()).then(function (resp) {
                    var res = option.pb.decode(resp.data);
                    console.log(res);
                    option.success(res);
                }).catch(function (error) {
                    console.error(error);
                    option.fail();
                });
            },
            initProtobuf () {
                if (typeof dcodeIO === 'undefined' || !dcodeIO.ProtoBuf) {
                    throw(new Error("ProtoBuf.js is not present."));
                }
                // 创建ProtoBuf
                var ProtoBuf = dcodeIO.ProtoBuf;
                var ClsModel = ProtoBuf.loadProtoFile("/static/pb/cls.proto");

                this.userListPB = ClsModel.build("UserList");
                this.questionInfoPb = ClsModel.build("QuestionInfoPb");
                this.calcPB = ClsModel.build("CalcPb");
                this.quesDetailsPb = ClsModel.build("QuesDetailsPb");
                // this.StuAnswerPb = ClsModel.build("StuAnswerPb");
            },
            loadWorkObj (w) {
                let workname = decodeURIComponent(this.workJson.workname);
                // this.groupnum = w.stugroup;
                // this.wType = w.worktype;
                // this.qtype = w.questype;
                this.questions = w.questions;
                // this.workjson = w.workjson;
                //拼接题面图片集合
                let picArray = this.workJson.imgpaths;
                let teacherUid = this.workJson.userid;
                for (let i = 0; i < picArray.length; i++) {
                    let item = this.interactPath + "/upload/" + teacherUid + "/" + picArray[i];
                    this.picUrls.push(item);
                }
                let quesArray = this.workJson.questions;
                for (let i = 0; i < quesArray.length; i++) {
                    this.answerList.push(quesArray[i].answer);
                }

                //初始化题面swiper
                this.initQuesImgSwiper();
            },
            /**
             * 初始化题面swiper
             */
            initQuesImgSwiper () {

                this.$nextTick(() => {
                    // 如果题面为横图，则宽为100%。竖图高为100%,否则宽高都为100%
                    var img_url = this.picUrls[0];
                    // 创建对象
                    var img = new Image();
                    // 改变图片的src
                    img.src = img_url;
                    // 加载完成执行
                    // img.onload = function(){
                    //     // 打印
                    //     var imgWidth = img.width;
                    //     var imgHeight = img.height;
                    //     if(imgWidth >= imgHeight){
                    //         $(".item-img").css({'width':'100%'})
                    //     } else{
                    //         $(".item-img").css({'height':'100%'})
                    //     }
                    // };

                    // var swiper = new Swiper('.swiper-container', {
                    //     pagination: {
                    //         el: '.swiper-pagination',
                    //         type: 'fraction'
                    //     },
                    //     navigation: {
                    //         nextEl: '.swiper-button-next',
                    //         prevEl: '.swiper-button-prev'
                    //     }
                    // });
                });
            },
            /**
             * 转换题目类型为中文
             */
            getQuestype (questype) {
                var workName = '';
                switch (questype) {
                    case 'choice':
                        workName = '选择题';
                        break;
                    case 'judge':
                        workName = '判断题';
                        break;
                    case 'subject':
                        workName = '主观题';
                        break;
                    default:
                        workName = '填空题';
                }
                return workName;
            },
            /**
             * 小题统计
             */
            loadCalcJson () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fcalc.pb",
                    pb: _this.calcPB,
                    success: function (resp) {
                        try {
                            _this.submitCount = parseInt(resp.stuCount);
                            _this.calcData = resp.calc;
                            _this.loadCalcData(resp);
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    fail: function () {
                    }
                });
            },
            loadCalcData (c) {
                for (var i = 0; i < c.calc.length; i++) {
                    var qid = c.calc[i].quesid;
                    this.loadQidJson(qid);
                }
            },
            loadQidJson (qid) {
                var qidUrl = this.interactPBPath + this.workId + "/" + qid + ".pb";
                var _this = this;
                _this.getData({
                    url: qidUrl,
                    pb: _this.quesDetailsPb,
                    success: function (resp) {
                        try {
                            _this.submitList.push(resp);
                            _this.loadQidObj(resp, qid);
                            if (_this.submitList.length == _this.questions.length) {
                                _this.shortSubimtList();
                            }
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    error: function () {
                        console.error("get resource err url=" + qidUrl);
                    }
                });
            },
            loadQidObj (data, qid) {
                var map = new Map();

                delete map._c;
                var detail = data.options;
                for (var j = 0; j < detail.length; j++) {
                    var result = detail[j];
                    map[result.title] = result.selectids;
                }

                var obj = Object.values(map);
                //根据数组长度排序  答案一致人数
                obj.sort(function (a, b) {
                    a.length > b.length
                }).map(function (value, index, array) {
                })

                var answers = Object.keys(map);
                var ids = Object.values(map);
                var others = [];
                var _answer = [];
                var _ids = [];
                var _count = [];
                for (var i = 0; i < answers.length; i++) {
                    _answer.push(decodeURIComponent(answers[i]));
                    _ids.push(ids[i]);
                    _count.push(ids[i].length);
                }
                this.fillList[qid] = {answers: _answer, ids: _ids, count: _count};
            },
            shortSubimtList () {
                var _this = this;
                var tempList = [];
                for (var i = 0; i < _this.questions.length; i++) {
                    tempList[i] = _this.submitList.getValue("quesid", this.questions[i].quesid);
                }
                this.submitList = tempList;
                this.calcScoreLevel();
                //处理submitList
                _this.handleSubmitList();

            },
            calcScoreLevel () {
                this.userList = this.$utils.removalArray(this.userList);
                for (var i = 0; i < this.userList.length; i++) {
                    var rightCount = 0;
                    console.log(this.workJson);
                    console.log(this.workjson);
                    for (var j = 0; j < this.calcData.length; j++) {
                        if (this.calcData[j].rightids.includes(this.userList[i]) || this.calcData[j].wrongids.includes(this.userList[i])) {
                            this.submitListIds.push(this.userList[i]);
                        }
                        if (this.calcData[j].rightids.includes(this.userList[i])) {
                            rightCount++;
                        }
                        //答错人数大于答对人数
                        if (this.calcData[j].rightids.length < this.calcData[j].wrongids.length)
                            this.wrongWeight.push(this.questions.getValue("quesid", this.calcData[j].quesid).quesgroup);
                    }
                    if (rightCount == this.questions.length) {
                        //全部答对
                        this.allRightIds.push(this.userList[i]);
                    }
                    if (rightCount >= this.questions.length * 0.9) {
                        //优秀
                        this.excellentIds.push(this.userList[i]);
                    } else if (rightCount >= this.questions.length * 0.7) {
                        //良好
                        this.goodIds.push(this.userList[i]);
                    } else if (rightCount >= this.questions.length * 0.6) {
                        //合格
                        this.badIds.push(this.userList[i]);
                    } else if (rightCount < this.questions.length * 0.6) {
                        //不合格(去掉未提交的人)
                        this.notGoodIds.push(this.userList[i]);
                        for (var k = 0; k < this.notGoodIds.length; k++) {
                            if (!this.submitListIds.includes(this.notGoodIds[k])) {
                                this.notGoodIds.splice(k, 1);
                            }
                        }
                    }
                }
                // reduseRepeat(this.notGoodIds);
                this.$utils.removalArray(this.notGoodIds);
                this.excellentCount = (this.excellentIds.length / this.submitCount);
                this.goodCount = (this.goodIds.length / this.submitCount);
                this.badCount = (this.badIds.length / this.submitCount);
                this.notGoodCount = (this.notGoodIds.length / this.submitCount);

                //错题集合排序
                this.wrongWeight = this.$utils.reduseRepeatSort(this.wrongWeight);
            },
            /**
             * 处理submitList
             */
            handleSubmitList () {
                let _this = this;
                // 获取柱形图数据data和label数组lables
                for (var i = 0; i < this.submitList.length; i++) {
                    var item = this.submitList[i];
                    if (item != null) {
                        var lables = [];
                        var data = [];
                        for (var j = 0; j < parseInt(item.optionscount); j++) {
                            var type = 0;
                            if (item.answer != "")// 如果不为空，判断本回答是否为正确答案
                                type = item.answer.indexOf(item.options[j].title) > -1 ? 1 : -1;
                            lables.push({value: _this.parseLableText(item.options[j].title, item), isset: type == 1});

                            var color = "#a7dcff";
                            if (type == -1)
                                color = "#ff5762";
                            else if (type == 1)
                                color = "#21e590";
                            data.push({
                                value: parseInt(item.options[j].selectids.length),
                                itemStyle: {color: color}
                            }); // 选择本选项的人数，和颜色（正确为绿色，否则为红色）
                        }

                        //选项数不等于item数  +1项为全对学生
                        if (item.options.length != parseInt(item.optionscount)) {
                            lables.push({value: "全对", isset: false}); // 柱形图下显示的文字和颜色
                            data.push({
                                value: parseInt(item.options[item.options.length - 1].selectids.length),
                                itemStyle: {color: "#0199ff"}
                            });
                        }

                        // 正确答案显示
                        item.rightAnswer = item.answer;
                        if (item.questype == "judge") {
                            lables.forEach(function (item) {
                                if (item.isset) {
                                    item.rightAnswer = item.text;
                                }
                            })
                        } else {
                            item.rightAnswer = item.answer.split(',').join('')
                        }

                        // 获取每一题中的举手人员的id数组
                        item.raisehandsList = _this.getHandsList(item.quesid);
                        item.data = data;
                        item.lables = lables;

                    }

                    this.$nextTick(() => {
                        _this.foreachAppendGraph();
                    });
                }
            },
            /**
             * 循环提交集合动态加载柱形图
             */
            foreachAppendGraph () {
                let _this = this;
                for (var i = 0; i < this.submitList.length; i++) {
                    _this.loadGraph('chartItem_zxt' + i, _this.submitList[i].lables, _this.submitList[i].data, _this.submitList[i],
                        _this.questions.getValue("quesid", _this.submitList[i].quesid).quesgroup, _this.submitList[i].raisehandsList);
                }
                this.$nextTick(() => {
                    _this.loadPie();
                });

            },
            /**
             * 根据题目id获取每一题的举手人员列表
             */
            getHandsList (quesid) {
                let _this = this;
                _this.raisehandsList = [];
                for (var i = 0; i < _this.calcData.length; i++) {
                    if (quesid == _this.calcData[i].quesid) {
                        _this.raisehandsList = _this.calcData[i].raisehands.split(',');
                        break;
                    }
                }
                return _this.raisehandsList;
            },
            selectAnswer ($event) {
                if ($event.currentTarget.className.indexOf("selectChecked") >= 0) {
                    $event.currentTarget.className = "selectAnswer"
                } else {
                    $event.currentTarget.className = "selectAnswer selectChecked"
                }
            },
            parseLableText (txt, item) {
                var wtype = item.questype;
                var showtype = this.workJson.showtype;
                if (wtype == "judge") {
                    var _true = "正确";
                    var _false = "错误";
                    if (showtype == "en") {
                        _true = "T";
                        _false = "F";
                    } else if (showtype == "icon") {
                        _true = "√";
                        _false = "×";
                    }
                    if (txt == "1")
                        return _true;
                    else
                        return _false;

                } else {
                    return txt;
                }
            },
            /**
             * 循环加载柱形图
             */
            loadGraph (id, labels, data, item, quesgroup, raisehandsList) {
                let _this = this;
                const option = {
                    color: ['#3398DB'],
                    tooltip: {
                        show: false,
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '10%',
                        containLabel: false
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: labels,
                            axisTick: {
                                alignWithLabel: true,
                                lineStyle: {
                                    color: '#c0d0e0'
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#c0d0e0'
                                }
                            },
                            axisLabel: {
                                width: 50,
                                height: 30,
                                backgroundColor: '#F6FCFF',
                                borderColor: '#F6FCFF',
                                borderWidth: 2,
                                borderRadius: 5,
                                formatter: function (name, index) {
                                    let value = labels[index];
                                    if (value.value == "全对") { // 若本体全对人数为0，则禁止点击赞赏按钮
                                        //这里字体颜色
                                        return '{a|' + name + '}';
                                    } else { // 若为单选题，正确的选项下
                                        if (item.options.length == parseInt(item.optionscount)) {
                                            var text = value.value;
                                            if (value.value == "正确" || value.value == "√" || value.value == "T") {
                                                text = "1"
                                            }
                                            if (value.value == "错误" || value.value == "×" || value.value == "F") {
                                                text = "0"
                                            }
                                            if (value.isset) {
                                                for (var i = 0; i < item.options.length; i++) {
                                                    if (item.options[i].title == 'F') {
                                                        item.options[i].title = '0';
                                                    }
                                                    if (item.options[i].title == text) {
                                                        if (item.options[i].selectids.length) {
                                                            _this.isSetAfter = true;
                                                            return '{b|' + name + '}';
                                                        } else {
                                                            _this.isSetAfter = true;
                                                            return '{a|' + name + '}';
                                                        }
                                                    }
                                                }
                                            } else {
                                                return '{a|' + name + '}';
                                            }
                                        }
                                        _this.isSetAfter = true;
                                        return '{a|' + name + '}';
                                    }
                                },
                                rich: {
                                    a: {
                                        color: '#0199ff',
                                        lineHeight: 30,
                                        fontSize: 18
                                    },
                                    b: {
                                        color: '#21e590',
                                        lineHeight: 30,
                                        fontSize: 18
                                    },
                                    c: {
                                        color: '#ff5762',
                                        lineHeight: 30,
                                        fontSize: 18
                                    }
                                }
                                // formatter: function (value, index) {
                                //     value = labels[index];
                                //     if (value.value == "全对") { // 若本体全对人数为0，则禁止点击赞赏按钮
                                //         return '<p class="ques-item-right ques" data-count="' + quesgroup + '" data-txt="' + (item.options[item.optionscount].selectids.length ? item.options[item.optionscount].selectids : "") + '"><span>' + value.value + '</span></p><p class="rightPraise ' + (item.options[item.optionscount].selectids.length ? "" : "disabledPraise") + '"></p>';
                                //     } else { // 若为单选题，正确的选项下，添加赞赏按钮
                                //         if (item.options.length == parseInt(item.optionscount)) {
                                //             var text = value.value;
                                //             if (value.value == "正确" || value.value == "√" || value.value == "T") {
                                //                 text = "1"
                                //             }
                                //             if (value.value == "错误" || value.value == "×" || value.value == "F") {
                                //                 text = "0"
                                //             }
                                //             if (value.isset) {
                                //                 for (var i = 0; i < item.options.length; i++) {
                                //                     if (item.options[i].title == 'F') {
                                //                         item.options[i].title = '0';
                                //                     }
                                //                     if (item.options[i].title == text) {
                                //                         if (item.options[i].selectids.length) {
                                //                             return '<p class="ques-item selected ques" data-count="' + quesgroup +
                                //                                 '" data-txt="' + item.options[i].selectids + '" ' +
                                //                                 'style="width: ' + (_this.workJson.questype == "judge" ? "88px" : "52px") + '"><span>'
                                //                                 + value.value + '</span></p><p class="'
                                //                                 + (_this.workJson.questype == "judge" ? "jugdeActivePraise" : "rightPraise") + '"></p>';
                                //                         } else {
                                //                             return '<p class="ques-item selected ques" data-count="' + quesgroup + '" ' +
                                //                                 'data-txt="" style="width: ' + (_this.workJson.questype == "judge" ? "88px" : "52px") + '"><span>'
                                //                                 + value.value + '</span></p><p class="disabledPraise '
                                //                                 + (_this.workJson.questype == "judge" ? "jugdeActivePraise" : "rightPraise") + '"></p>';
                                //                         }
                                //                     }
                                //                 }
                                //             } else {
                                //                 return '<p class="ques-item ques" data-count="' + quesgroup + '" data-txt="" style="width: ' + (_this.workJson.questype === "judge" ? "88px" : "52px") + '"><span>' + value.value + '</span></p>';
                                //             }
                                //         }
                                //         return '<p class="ques ques-item ' + (value.isset ? "selected" : "") + '" data-txt="" data-count="' + quesgroup + '"><span>' + value.value + '</span></p>';
                                //     }
                                // }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            show: false,
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: '直接访问',
                            type: 'bar',
                            barWidth: '30%',
                            data: data,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top',
                                    formatter: '{c}人',
                                    color: '#000',
                                    fontSize: 18
                                }
                            }
                        }
                    ]
                };

                let dataChart = this.$echarts.init(document.getElementById(id));
                dataChart.setOption(option);
                window.addEventListener('resize', function () {
                    dataChart.resize();
                });

                dataChart.on('click', function (params) {
                    var textValue = '';
                    // 柱形图点击事件，弹出模态框，显示选择了这个选项的所有人
                    if (params.name == "正确" || params.name == "√" || params.name == "T") {
                        textValue = 1;
                    }
                    if (params.name == "错误" || params.name == "×" || params.name == "F") {
                        textValue = 0;
                    }
                    if (params.name == "全对") {
                        textValue = "allright";
                    }
                    _this.stuList = [];
                    _this.raisehandsList = [];
                    for (var i = 0; i < item.options.length; i++) {
                        if (item.options[i].title == params.name || item.options[i].title == textValue) {
                            item.options[i].selectids.forEach(function (item) {
                                _this.stuList.push(item);
                            });
                        }
                    }
                    _this.raisehandsList = raisehandsList;
                    _this.isShowModel = true;
                });
            },
            /**
             * 加载拼图
             */
            loadPie () {
                let dataSourcePie = this.$echarts.init(document.getElementById('pieContainer'));
                let pieData = [];
                pieData.push(
                    {
                        name: '优秀',
                        value: this.excellentCount
                    },
                    {
                        name: '良好',
                        value: this.goodCount
                    },
                    {
                        name: '及格',
                        value: this.badCount
                    },
                    {
                        name: '不合格',
                        value: this.notGoodCount
                    });
                const option = {
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: '90%',
                            center: ['50%', '50%'],
                            data: pieData,
                            labelLine: {
                                show: false
                            },
                            hoverAnimation: false,
                            hoverOffset: 0,
                            color: this.colorArr
                        }
                    ]
                };
                dataSourcePie.setOption(option);
            },
            /**
             * 预览图片
             */
            previewImg (imgArr, index) {
                this.previewMode = true;
                //处理图片集合
                this.$refs.previewSlider.swiperInitByImgArr(this.convertImgArr(imgArr), index);
            },
            // 关闭预览
            closePreview (type) {
                this[type] = false;
            },
            /**
             *处理图片集合
             */
            convertImgArr (imgArr) {
                let imgArrData = [];
                imgArr.forEach(function (item) {
                    let imgObj = {};
                    imgObj.url = item;
                    imgArrData.push(imgObj);
                });

                return imgArrData;
            },
            /**
             * 点击提问人数查看学生名单
             */
            lookStuNames (e) {
                if (e.currentTarget.className.indexOf('packUpIcon') > -1) {
                    e.currentTarget.className = "askNumber unfoldIcon";
                    e.currentTarget.children[1].style.display = "none"
                } else {
                    e.currentTarget.className = "askNumber packUpIcon";
                    e.currentTarget.children[1].style.display = "block"
                }
            }
        },
        mounted () {
            //根据报告id获取报告详情
            this.initProtobuf();
            this.loadUserList();
        }
    }
</script>

<style lang="css" scoped>
    @import "../../../../style/cloudReport/normalize.css";
    @import "../../../../style/cloudReport/main.css";
    @import "../../../../style/cloudReport/objectReport.css";
</style>
<style lang="css">
    .swiper-container {
        width  : 100%;
        height : 100%;
    }

    .swiper-slide {
        text-align              : center;
        font-size               : 18px;
        background              : #fff;

        /* Center slide text vertically */
        display                 : -webkit-box;
        display                 : -ms-flexbox;
        display                 : -webkit-flex;
        display                 : flex;
        -webkit-box-pack        : center;
        -ms-flex-pack           : center;
        -webkit-justify-content : center;
        justify-content         : center;
        -webkit-box-align       : center;
        -ms-flex-align          : center;
        -webkit-align-items     : center;
        align-items             : center;
    }
</style>
